module.exports = __webpack_public_path__ + "img/times.5a9d31f.jpg";